import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {WidgetConfiguration} from "./widget-configuration";
import {MapViewConfiguration} from "./view-configuration";

// *Geo.js Properties*
@JsonObject()
export class OverwriteConfiguration {
    /**
     * label text überschreiben
     */
    @JsonProperty()
    declare labels?: HashMap<string>;
    /**
     * label entfernen
     */
    @JsonProperty()
    declare removeLabels?: string[];

    @JsonProperty()
    declare reorder?: string[];

    /**
     * label anhängen
     */
    @JsonProperty()
    declare append?: __esri.SymbolTableElementInfo[];

    constructor() {}
}

@JsonObject()
export class LegendConfiguration extends WidgetConfiguration {
    /**
     * Collection of [ActiveLayerInfo](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend-support-ActiveLayerInfo.html) objects used by the legend view to display data in the legend.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend.html#activeLayerInfos)
     */
    // @JsonProperty()
    // activeLayerInfos?: CollectionProperties<ActiveLayerInfoProperties>;
    /**
     * Indicates whether to show the [Basemap](https://developers.arcgis.com/javascript/latest/api-reference/esri-Basemap.html) layers in the Legend.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend.html#basemapLegendVisible)
     */
    @JsonProperty()
    declare basemapLegendVisible?: boolean;
    /**
     * Indicates the heading level to use for the legend title.
     *
     * @default 3
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend.html#headingLevel)
     */
    @JsonProperty()
    declare headingLevel?: number;
    /**
     * When `true`, layers will only be shown in the legend if they are visible in the view's extent.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend.html#hideLayersNotInCurrentView)
     */
    @JsonProperty()
    declare hideLayersNotInCurrentView?: boolean;
    /**
     * Specifies a subset of the layers to display in the legend.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend.html#layerInfos)
     */
    @JsonProperty()
    declare layerInfos?: __esri.LegendLayerInfos[];
    /**
     * If a layer uses a unique value render, only features that satisfy the layer's [definition expression](https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-FeatureLayer.html#definitionExpression) will be displayed in the legend when set to true.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend.html#respectLayerDefinitionExpression)
     */
    @JsonProperty()
    declarerespectLayerDefinitionExpression?: boolean;
    /**
     * Determines whether to respect the properties of the layers in the map that control the legend's visibility (`minScale`, `maxScale`, `legendEnabled`).
     *
     * @default true
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend.html#respectLayerVisibility)
     */
    @JsonProperty()
    declare respectLayerVisibility: boolean;
    /**
     * Indicates the style of the legend.
     *
     * @default "classic"
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend.html#style)
     */
    declare style?: string | __esri.LegendStyle;
    /**
     * A reference to the [MapView](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-MapView.html) or [SceneView](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-SceneView.html).
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend.html#view)
     */
    declare view?: (MapViewConfiguration & { type: "2d" }); // | (SceneViewConfiguration & { type: "3d" });
    /**
     * The view model for this widget.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Legend.html#viewModel)
     */
    // viewModel?: LegendViewModelProperties;

    /**
     * *Geo.js Properties*
     * MapViewer specific template configuration per layer
     */
    @JsonProperty()
    declare overwriteLayerInfos?: HashMap<OverwriteConfiguration>;
    /**
     * *Geo.js Properties*
     * MapViewer specific template configuration per layer
     */
    @JsonProperty()
    declare reorder?: string[];
    constructor() {
        super();
    }
}
